import fileSys from "../fileoprators/fileSystem";
import SettingsOprator from "./settingsoprator";
import { DRYEYEMENUS } from "../shared/consts";
const DEFAULTSET = {
  dryeye: {
    templates: [
      {
        label: "默认模版",
        value: "default",
        default: true,
        items: DRYEYEMENUS.filter((v) => v.key !== "report").map(({ key }) => ({
          key,
          show: true
        }))
      }
    ],
    template: "default"
  }
};

class DetectSettings extends SettingsOprator {
  constructor() {
    super(fileSys.getCfgPath("detectsettings.json"), DEFAULTSET);
  }
  getDelectSettings() {
    return this.getSettings();
  }
  saveDelectSettings(settings) {
    this.saveSettings(settings);
  }
}

export default DetectSettings;



// WEBPACK FOOTER //
// ./src/settings/delectsettings.js